import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { useConsent } from '../contexts/ConsentContext';
import { ENV_CONFIG } from '../config/environment';
import { metaPixelTrackPageView } from '../utils/metaPixel';

/**
 * Envoie un PageView sur chaque changement de route SPA.
 * Le premier événement après consentement est déjà couvert par loadAndInitMetaPixel.
 */
const MetaPixelPageViews: React.FC = () => {
  useTranslation('common');
  const location = useLocation();
  const { consent } = useConsent();
  const routePageViewReady = useRef(false);
  const { ENABLED } = ENV_CONFIG.TRACKING;

  useEffect(() => {
    if (consent === 'denied') {
      routePageViewReady.current = false;
    }
  }, [consent]);

  useEffect(() => {
    if (Capacitor.isNativePlatform() || !ENABLED || consent !== 'granted') {
      return;
    }
    if (!routePageViewReady.current) {
      routePageViewReady.current = true;
      return;
    }
    metaPixelTrackPageView();
  }, [location.pathname, location.search, consent, ENABLED]);

  return null;
};

export default MetaPixelPageViews;
